$('.home_banner').slick({
  dots: false,
  arrows: true, // Enable arrows
  infinite: true,
  speed: 800, // Smooth transition speed
  slidesToShow: 1,
  autoplay: true,
  autoplaySpeed: 4000, // Auto slide every 4 seconds
  fade: true, // Smooth fade transition
  cssEase: 'linear',
  prevArrow: `<button type="button" class="slick-prev">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="15 18 9 12 15 6"></polyline>
                </svg>
              </button>`,
  nextArrow: `<button type="button" class="slick-next">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              </button>`
});

nodeMarquee({
  parent: '.main_announcement',
  speed: 1
});
